import { __assign } from "tslib";
import * as React from 'react';
import { SearchResultHeader, } from '../search-result-header';
import s from './search-result.scss';
import { SolutionGridWrapper, } from '../../solution-grid-wrapper/solution-grid-wrapper';
import { Box } from 'wix-style-react';
import { FluidContainer } from '../../FluidContainer';
export var SearchResult = function (_a) {
    var searchResultHeaderProps = _a.searchResultHeaderProps, solutionGridWrapperProps = _a.solutionGridWrapperProps;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { backgroundColor: '#f0f4f7', height: '132px' }),
        React.createElement(FluidContainer, { className: s.pageSettings },
            React.createElement(SearchResultHeader, __assign({}, searchResultHeaderProps)),
            React.createElement(SolutionGridWrapper, __assign({}, solutionGridWrapperProps, { referralSectionName: "search-result" })))));
};
//# sourceMappingURL=search-result.js.map